(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    (() => {
 let frame;
 const update = () => {
  frame = null;
  if (!window.matchMedia('(min-width:990px)').matches) return;
  document.querySelectorAll('.section-header details.wl-menu-compact').forEach(details => {
   const header = details.closest('.header-wrapper');
   if (!header) return;
   const bottom = header.getBoundingClientRect().bottom;
   details.style.setProperty('--wl-submenu-top', Math.ceil(bottom - details.getBoundingClientRect().top) + 'px');
   details.style.setProperty('--wl-submenu-height', Math.max(0, window.innerHeight - bottom - 16) + 'px');
  });
 };
 const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
 const observer = new ResizeObserver(schedule);
 const observe = () => {
  document.querySelectorAll('.section-header .header-wrapper').forEach(header => observer.observe(header));
  schedule();
 };
 document.addEventListener('toggle', event => {
  if (event.target.matches('details.wl-menu-compact')) update();
 }, true);
 window.addEventListener('resize', schedule);
 window.addEventListener('scroll', schedule, {passive:true});
 document.addEventListener('shopify:section:load', observe);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe, {once:true});
 else observe();
})();
  } catch(e) { console.error(e); }
})();

})();
